import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface IndicatorElementProps {
  value: string;
}

export function IndicatorElement({ value }: IndicatorElementProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="50%"
      width="25px"
      height="25px"
      border="1px solid #022D58"
    >
      <Text fontSize="1rem">{value}</Text>
    </Box>
  );
}
